import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../firebase/auth.tsx";

interface DefaultRouteProps {
  children: React.ReactNode;
}

const DefaultRoute: React.FC<DefaultRouteProps> = ({ children }) => {
  const { userRole } = useAuth();

  if (userRole) {
    return <Navigate to="/main" />;
  }

  return <>{children}</>;
};

export { DefaultRoute };
